<template>
  <div>
    <div class="ma-auto">
      <div class="">
        <v-textarea style="border-radius: 10px;" v-model="text" rows="4" :label="'Ваш ответ'" outlined></v-textarea>
      </div>
      <div class="ta-center m-t-10 btn-content">
        <v-btn :loading="loading" @click="answer" class="mt-8" large color="info">
          Ответить на вопрос
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  props: {
    data: Object,
  },
  components: {
    
  },
  created() {
 
  },
  data() {
    return {
      text: null,
      loading:false
    }
  },
  methods: {
    async answer() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 500);
    }
  },
}
</script>
